"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPLICATION_CATEGORY_KEY = 'base';
exports.APPLICATION_COMPONENT_KEY = 'application';